export default function FeatureHighlights() {
  const features = [
    {
      icon: 'ri-truck-line',
      title: 'Fast Delivery',
      description: 'Free delivery on orders over KSh 5,000 in Nairobi & Mombasa. Same-day delivery available.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Secure Payments',
      description: 'Pay with M-Pesa, card, or cash on delivery. Your data is always protected.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Easy Returns',
      description: 'Not satisfied? Return within 7 days for a full refund or exchange.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Our customer care team is available round the clock to assist you.',
    },
  ];

  return (
    <section className="w-full py-8 md:py-12 px-4 md:px-6 lg:px-8 border-t border-background-50/10 -mt-8 md:-mt-10 lg:-mt-12 relative z-20 rounded-t-2xl md:rounded-t-3xl">
      <div className="w-full grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {features.map((f) => (
          <div
            key={f.title}
            className="flex items-start gap-3 md:gap-4 p-4 md:p-5 rounded-xl md:rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-200 hover:shadow-sm transition-all"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0">
              <i className={`${f.icon} text-xl md:text-2xl text-primary-500`} />
            </div>
            <div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{f.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{f.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}